/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type MunicipalitiesEnum =
  (typeof MunicipalitiesEnum)[keyof typeof MunicipalitiesEnum];

export const MunicipalitiesEnum = {
  NUMBER_101: 101,
  NUMBER_147: 147,
  NUMBER_151: 151,
  NUMBER_153: 153,
  NUMBER_155: 155,
  NUMBER_157: 157,
  NUMBER_159: 159,
  NUMBER_161: 161,
  NUMBER_163: 163,
  NUMBER_165: 165,
  NUMBER_167: 167,
  NUMBER_169: 169,
  NUMBER_173: 173,
  NUMBER_175: 175,
  NUMBER_183: 183,
  NUMBER_185: 185,
  NUMBER_187: 187,
  NUMBER_201: 201,
  NUMBER_190: 190,
  NUMBER_210: 210,
  NUMBER_217: 217,
  NUMBER_219: 219,
  NUMBER_223: 223,
  NUMBER_230: 230,
  NUMBER_240: 240,
  NUMBER_250: 250,
  NUMBER_260: 260,
  NUMBER_270: 270,
  NUMBER_400: 400,
  NUMBER_411: 411,
  NUMBER_766: 766,
  NUMBER_615: 615,
  NUMBER_756: 756,
  NUMBER_657: 657,
  NUMBER_661: 661,
  NUMBER_665: 665,
  NUMBER_760: 760,
  NUMBER_671: 671,
  NUMBER_706: 706,
  NUMBER_707: 707,
  NUMBER_710: 710,
  NUMBER_727: 727,
  NUMBER_730: 730,
  NUMBER_741: 741,
  NUMBER_740: 740,
  NUMBER_746: 746,
  NUMBER_751: 751,
  NUMBER_779: 779,
  NUMBER_791: 791,
  NUMBER_773: 773,
  NUMBER_787: 787,
  NUMBER_810: 810,
  NUMBER_813: 813,
  NUMBER_860: 860,
  NUMBER_846: 846,
  NUMBER_825: 825,
  NUMBER_840: 840,
  NUMBER_849: 849,
  NUMBER_851: 851,
  NUMBER_820: 820,
  NUMBER_253: 253,
  NUMBER_259: 259,
  NUMBER_265: 265,
  NUMBER_269: 269,
  NUMBER_306: 306,
  NUMBER_316: 316,
  NUMBER_326: 326,
  NUMBER_329: 329,
  NUMBER_320: 320,
  NUMBER_330: 330,
  NUMBER_340: 340,
  NUMBER_350: 350,
  NUMBER_336: 336,
  NUMBER_370: 370,
  NUMBER_390: 390,
  NUMBER_360: 360,
  NUMBER_376: 376,
  NUMBER_410: 410,
  NUMBER_420: 420,
  NUMBER_430: 430,
  NUMBER_440: 440,
  NUMBER_450: 450,
  NUMBER_461: 461,
  NUMBER_479: 479,
  NUMBER_480: 480,
  NUMBER_482: 482,
  NUMBER_492: 492,
  NUMBER_510: 510,
  NUMBER_540: 540,
  NUMBER_550: 550,
  NUMBER_580: 580,
  NUMBER_561: 561,
  NUMBER_563: 563,
  NUMBER_530: 530,
  NUMBER_573: 573,
  NUMBER_575: 575,
  NUMBER_607: 607,
  NUMBER_621: 621,
  NUMBER_630: 630,
} as const;
